import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Space,
  Table,
  Button,
  Select,
  Form,
  Input,
  Popconfirm,
  Spin,
} from "antd";
import { ProfileOutlined } from "@ant-design/icons";
import type { ColumnsType, ColumnType } from "antd/es/table";
import type { InputRef } from "antd";
import type { FilterConfirmProps } from "antd/es/table/interface";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { cloneDeep } from "lodash";
import { RoleType } from "../../models/Role";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import { activeUser } from "../../services/AuthServices";
import { RegistrationStatus } from "../../models/Registration";
import { Participant } from "../../models/Participant";
import { PdfPreview } from "../../components/PdfPreview/PdfPreview";
import { getParticipantListReportTemplate } from "../../document-templates/ParticipantListReportTemplate";
import { getAllParticipantsInactive } from "../../services/ParticipantService";
import { formatDate, formatTime } from "../../core/Utility";
import { getAllEvents } from "../../services/EventService";
import "./NotificationParticipantListPage.scss";
import { Toast } from "primereact/toast";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import EmailModal from "../../components/EmailModal/EmailModal";
import PopUp from "./PopUp";
///// REDUX IMPORT
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../store-redux/slices/ChangePageSlice";

const NotificationParticipantListPage = () => {
  const navigate = useNavigate();
  const { setBreadcrumb } = useApplicationContext();

  const toast = useRef<any>(null);
  const [participantList, setParticipantList] = useState<Participant[]>([]);
  const [filteredParticipantList, setFilteredParticipantList] = useState<
    Participant[]
  >([]);
  const [searchText, setSearchText] = useState<string>("");
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const [allEventOptions, setAllEventOptions] = useState<
    { text: string; value: string }[]
  >([]);
  const [typeOptions, setTypeOptions] = useState<
    { text: string; value: string }[]
  >([]);
  const [yearOptions, setYearOptions] = useState<
    { text: string; value: string }[]
  >([]);
  const [companyOptions, setCompanyOptions] = useState<
    { text: string; value: string }[]
  >([]);
  const [filters, setFilters] = useState({ active: true, fcmToken: true });
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [openExportButtons, setOpenExportButtons] = useState<boolean>(false);
  const searchInput = useRef<InputRef>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [selectionType, setSelectionType] = useState<"checkbox" | "radio">(
    "checkbox"
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [pdfData, setPdfData] = useState<any>(
    getParticipantListReportTemplate(filteredParticipantList)
  );

  const downloadPdfDocument = useRef(null);
  const printPdfDocument = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const [paginationNumber, setPaginationNumber] = useState<any>(30);

  ///// IMPLEMENTATION REDUX
  const dispatch = useDispatch();
  const currentPage = useSelector((state: any) => state.changePage.currentPage);
  ///// END IMPLEMENTATION REDUX

  const statusOptions = [
    { text: "Uplaćeno", value: RegistrationStatus.Paid },
    { text: "Rezervisano", value: RegistrationStatus.Reserved },
    { text: "Odobreno", value: RegistrationStatus.Approved },
  ];

  useEffect(() => {
    setBreadcrumb(["Učesnici", "Lista učesnika - notifikacija"]);
    fetchAllParticipants(filters);
  }, []);

  useEffect(() => {
    fetchAllParticipants(filters);
  }, [filters]);

  const fetchAllParticipants = (filters: any) => {
    setActiveSpinner(true);
    let copyOfNewParticipants: Participant[] = [];

    getAllParticipantsInactive(filters)
      .then((response) => {
        response.data.result.map((item: any) => {
          let oneParticipant = cloneDeep(item);
          oneParticipant.companyName =
            oneParticipant?.registration?.registrationCompanyName ?? "/";
          copyOfNewParticipants.push(oneParticipant);
        });

        let sortedParticipant = [...copyOfNewParticipants];
        sortedParticipant.sort(function (a: any, b: any) {
          var datumA: any = new Date(a.registration.createdAt);
          var datumB: any = new Date(b.registration.createdAt);

          return datumB - datumA;
        });

        const listData = sortedParticipant.map((el: any, i: number) => {
          return { ...el, key: i };
        });

        setParticipantList(listData);
        setFilteredParticipantList(listData);

        let newTypeOptions: { text: string; value: string }[] = [];
        response.data.result?.map((item: any) => {
          newTypeOptions.push({ text: item.type, value: item.type });
        });
        newTypeOptions = newTypeOptions.filter(
          (
            value,
            index,
            self //remove duplicate
          ) => index === self.findIndex((t) => t.text === value.text)
        );
        setTypeOptions(newTypeOptions);
        //////

        let newCompanyRegistrationList: { text: string; value: string }[] = [];
        response.data.result?.map((item: any) => {
          if (item.registration.registrationCompanyName !== null) {
            newCompanyRegistrationList.push({
              text: item.registration.registrationCompanyName,
              value: item.registration.registrationCompanyName,
            });
          }
        });
        newCompanyRegistrationList = newCompanyRegistrationList.filter(
          (
            value,
            index,
            self //remove duplicate
          ) => index === self.findIndex((t) => t.text === value.text)
        );
        setCompanyOptions(newCompanyRegistrationList);
        setPageNumber(currentPage); /// - SET NUMBER PAGE FROM STORE
      })
      .then(() => {
        getAllEvents().then((eventResponse) => {
          let newEventOptions: { text: string; value: string }[] = [];
          let newYearOptions: { text: string; value: string }[] = [];
          eventResponse?.data?.result?.map((eventItem: any) => {
            newEventOptions.push({
              text: eventItem.name,
              value: eventItem.name,
            });
            newYearOptions.push({
              text: new Date(eventItem.dateFrom).getFullYear().toString(),
              value: new Date(eventItem.dateFrom).getFullYear().toString(),
            });
          });
          setAllEventOptions(newEventOptions);
          newYearOptions = newYearOptions.filter(
            (
              value,
              index,
              self //remove duplicate
            ) => index === self.findIndex((t) => t.text === value.text)
          );
          setYearOptions(newYearOptions);
        });
      })
      .finally(() => setActiveSpinner(false))
      .catch((err) => console.log(err));
  };

  type DataIndex = keyof Participant;
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<Participant> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Pretraži`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              handleSearch(selectedKeys as string[], confirm, dataIndex);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, border: "none" }}
          >
            Pretraži
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              close();
              setSearchedColumn("");
            }}
            size="small"
            style={{ width: 90 }}
          >
            Poništi
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#C7363D" : undefined }} />
    ),
    onFilter: (value, record) =>
      (record[dataIndex] ?? "")
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
            color: "#0D4077",
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<Participant | any> = [
    {
      title: "Red. broj",
      width: 100,
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName, text, index) => {
        return <span className="blue-text">{index + 1}</span>;
      },
    },
    {
      title: "Ime",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => (a.firstName < b.firstName ? -1 : 1),
      //defaultSortOrder: "ascend",
      render: (firstName, record) => {
        return <span className="blue-text name-container">{firstName}</span>;
      },
      ...getColumnSearchProps("firstName"),
    },
    {
      title: "Prezime",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => (a.lastName < b.lastName ? -1 : 1),
      render: (lastName) => <span className="blue-text">{lastName}</span>,
      ...getColumnSearchProps("lastName"),
    },
    {
      title: "Događaj",
      dataIndex: "event",
      key: "event",
      sorter: (a, b) =>
        (a?.event?.name ?? "") < (b?.event?.name ?? "") ? -1 : 1,
      filters: allEventOptions, //@ts-ignore
      onFilter: (value: string, record) => record?.event?.name === value,
      render: (event) => <span className="blue-text">{event?.name}</span>,
    },
    {
      title: "Tip učesnika",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => ((a?.type ?? "") < (b?.type ?? "") ? -1 : 1),
      filters: typeOptions, //@ts-ignore
      onFilter: (value: string, record) => record?.type === value,
      render: (type) => (
        <span className="blue-text">
          {type == "Nepoznat" || type == null || !type ? "/" : type}
        </span>
      ),
    },
    {
      title: "Pravno lice",
      dataIndex: "companyName",
      key: "companyName",
      sorter: (a, b) =>
        (a?.companyName ?? "") < (b?.companyName ?? "") ? -1 : 1,
      render: (companyName) => (
        <span className="blue-text">{companyName ?? "/"}</span>
      ),
      ...getColumnSearchProps("companyName"),
    },
    {
      title: "Opcije",
      fixed: "right",
      width: 150,
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <span className="action-button" onClick={() => openModal()}>
            Kreiraj
          </span>
        </Space>
      ),
    },
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const handleOpenFilters = () => {
    setOpenFilter(!openFilter);
  };

  const handeSelection = (name: string, newValue: any) => {
    setFilters({ ...filters, [name]: newValue });
  };

  // populate pdf when data changes
  useEffect(() => {
    const newPdf = getParticipantListReportTemplate(filteredParticipantList);
    setPdfData(newPdf);
  }, [filteredParticipantList]);

  const handleOpenExportButtons = () => {
    setOpenExportButtons(!openExportButtons);
  };

  const handleEmailButton = () => {
    setShowEmailModal(!showEmailModal);
  };

  const handleExcelButton = () => {
    const filterObject = filteredParticipantList.map((el: any) => {
      return {
        Ime: el.firstName,
        Prezime: el.lastName,
        Dogadjaj: el.event.name,
        Tip: el.type,
        Kompanija: el.companyName ?? "/",
        Telefon: el.phone,
        Status: el.registration.status,
      };
    });

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(filterObject);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Lista učesnika ");
    });
    setOpenExportButtons(false);
  };

  const saveAsExcelFile = (buffer: any, fileName: string) => {
    import("file-saver").then((module: any) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        module.default.saveAs(
          data,
          fileName +
            "_" +
            formatDate(new Date()) +
            "_" +
            formatTime(new Date()) +
            EXCEL_EXTENSION
        );
      }
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: Participant[] | any
    ) => {
      setSelectedParticipant(selectedRows);
      const allRowKeys = selectedRows.map((item: any) => item.id);
      setSelectedRowKeys(allRowKeys);
    },
    getCheckboxProps: (record: Participant | any) => ({
      disabled: record.id === "Disabled User", // Column configuration not to be checked
      name: record.id,
    }),
  };

  const checkedParticipantFunc = (participantsSend: string[]) => {
    if (participantsSend) {
      setSelectedRowKeys(participantsSend);
    }
  };

  const openModal = () => {
    if (selectedParticipant.length < 1) {
    } else {
      setIsModalOpen(!isModalOpen);
    }
  };

  const closeModalFunc = () => {
    setSelectedRowKeys([]);
    setSelectedParticipant([]);
    setIsModalOpen(false);
    let copyPar = [...participantList];
    let newArr = copyPar.map((par: any) => {
      return { ...par, select: false };
    });

    setParticipantList(newArr);
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <PopUp
        openModal={isModalOpen}
        closeModalFunc={closeModalFunc}
        selectedParticipant={selectedParticipant}
        participantList={participantList}
        checkedParticipantFunc={checkedParticipantFunc}
      />
      <div className="participant-list">
        <Spin spinning={activeSpinner}>
          <div className="overview-legend-right">
            <div className="btn-container">
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={"primary"}
                function={() => {
                  handleOpenFilters();
                }}
                text={" Dodatni filteri"}
              />
            </div>
          </div>
          {openFilter ? (
            <div className="filters-container">
              <Form.Item name="selectedFilters" label="Godina:">
                <Select
                  placeholder="Izaberite godinu"
                  options={yearOptions}
                  onChange={(newValue) => handeSelection("year", newValue)}
                  allowClear
                />
              </Form.Item>
              <Form.Item name="selectedFilters" label="Tip učesnika:">
                <Select
                  placeholder="Izaberite tip učesnika "
                  options={typeOptions}
                  onChange={(newValue) =>
                    handeSelection("participantType", newValue)
                  }
                  allowClear
                />
              </Form.Item>
              <Form.Item name="selectedFilters" label="Pravno lice:">
                <Select
                  placeholder="Izaberite pravno lice"
                  options={companyOptions}
                  onChange={(newValue) => handeSelection("company", newValue)}
                  allowClear
                />
              </Form.Item>
            </div>
          ) : null}

          <Table
            sticky={true}
            scroll={{ x: 1500 }}
            columns={columns}
            rowKey={(data) => {
              return data.id;
            }}
            // pagination={{
            //   current: pageNumber,
            //   onChange(current) {
            //     setPageNumber(current);
            //     dispatch(setCurrentPage(current)); /// DISPATCH ACTION FROM REDUX
            //   },
            //   // defaultPageSize: 3,
            //   showSizeChanger: true,
            //   pageSizeOptions: ["30", "50", "100"],
            // }}
            pagination={false}
            dataSource={participantList}
            onChange={(pagination, filters, sorter, extra) => {
              setPaginationNumber(pagination.pageSize);
            }}
            className="table-container"
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
          />
          <div className="btn-container footer-btn-container">
            <CustomButton
              // danger={false}
              // htmlType={"submit"}
              type={"primary"}
              function={() => {
                setShowEmailModal(true);
              }}
              text={"E-mail obaveštenje"}
            />
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={"primary"}
              function={() => {
                handleOpenExportButtons();
              }}
              text={"Export"}
            />
          </div>
          {openExportButtons ? (
            <div className="btn-container footer-btn-container">
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={"primary"}
                function={() => {
                  handleExcelButton();
                }}
                text={"Excel"}
              />
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={"primary"}
                function={() => {
                  if (downloadPdfDocument.current) {
                    // @ts-ignore
                    downloadPdfDocument.current();
                  }
                }}
                text={"PDF"}
              />
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={"primary"}
                function={() => {
                  if (printPdfDocument.current) {
                    // @ts-ignore
                    printPdfDocument.current();
                  }
                }}
                text={"Štampa"}
              />
            </div>
          ) : null}
          <div className="document-preview">
            <PdfPreview
              pdfDefinition={pdfData}
              downloadDocument={downloadPdfDocument}
              printDocument={printPdfDocument}
              documentName={`Lista_ucesnika_${
                formatDate(new Date()) + "_" + formatTime(new Date())
              }.pdf`}
            />
          </div>
        </Spin>
        {showEmailModal && (
          <EmailModal
            toast={toast}
            participantList={participantList}
            handleEmailButton={handleEmailButton}
            showEmailModal={showEmailModal}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default NotificationParticipantListPage;
